import {assert} from 'Asserts';
import {NoteLinkedStructuredTable} from 'notebook/structured-tables/StructuredTablePlugin';
import {hasNLO, isStructuredTable} from 'notebook/TypePredicates';
import {NotePart, NotePartWithItem} from 'notebook/util/NoteUtilConstants';

export function isStructuredTableNotePart(
  notePart: NotePart
): notePart is NotePartWithItem<NoteLinkedStructuredTable> {
  return hasNLO(notePart) && isStructuredTable(notePart.item);
}

export function getStructuredTableNoteParts(noteParts: Array<NotePart>): Array<NoteLinkedStructuredTable> {
  return noteParts.reduce<Array<NoteLinkedStructuredTable>>((acc, p) => {
    if (isStructuredTableNotePart(p)) {
      acc.push(p.item);
    }
    return acc;
  }, []);
}

export function assertIsStructuredTableNotePart(
  notePart: NotePart
): asserts notePart is NotePart & {item: NoteLinkedStructuredTable} {
  assert(isStructuredTableNotePart(notePart), 'Expected notePart to be a StructuredTable');
}
